import React from 'react';
import * as Styles from './Styles';
import Selectable from './Selectable';
import PaginatedDescription from '../../../../../components/paginatedDescription/PaginatedDescription';
import * as ExtendedContent from './extendedContent';
import { IRisk } from '../../../../../models/Dictionaries';
import * as FormManager from '../../../../../reducers/ui/form';

const TopContentTile = (props: { label: string; sub: string }) => (
	<Styles.TileContainer>
		<p>{props.label.split(',').join(' ')}</p>
		<div />
		<p>{props.sub}</p>
	</Styles.TileContainer>
);

export const OCHeading = () => (
	<>
		<p>ubezpieczenie Odpowiedzalności Cywilnej zawodowej</p>
		<p>
			wybierz sumę gwarancyjną ubezpieczenia{' '}
			<span>(zaznacz odpowiedni kafelek)</span>
		</p>
	</>
);

export const OCTopContent = (props: {
	risks: IRisk[];
	selectedRisksIds: number[];
}) => (
	<Styles.TopContentContainer>
		<Styles.SelectablesContainer>
			{props.risks.map((risk) => {
				const riskState = props.selectedRisksIds.includes(risk.riskId);

				return (
					<Selectable
						key={risk.riskId}
						label={
							<TopContentTile
								label={`${risk.riskInsuranceAmount.toLocaleString()} zł`}
								sub={`${risk.riskContribution} zł`}
							/>
						}
						onClick={() =>
							FormManager.toggleSelectRisk(risk.riskId, 'oc')
						}
						selected={riskState}
					/>
				);
			})}
			<Selectable
				label={'NIE WYBIERAM'}
				onClick={() => FormManager.clearSelectedOCRisks()}
				selected={
					!props.risks.some((el) =>
						props.selectedRisksIds.includes(el.riskId)
					)
				}
				className="no-select"
				style={{ fontSize: '15px' }}
			/>
		</Styles.SelectablesContainer>
	</Styles.TopContentContainer>
);

export const OCBottomContent = (props: { selectOCExtendedRisk: boolean }) => (
	<div>
		<Styles.OCBottomFont>
			Czy chcesz rozszerzyć zakres dobrowolnego ubezpieczenia OC
			ratowników WOPR na{' '}
			<span>cały świat, z wyłączeniem USA i Kanady?</span>
		</Styles.OCBottomFont>
		<Styles.OCBottomSelectables>
			<Selectable
				style={{ height: '45px', fontWeight: '600', fontSize: '15px' }}
				label="TAK"
				onClick={() => FormManager.toggleSelectOCExtendedRisk(true)}
				selected={props.selectOCExtendedRisk}
			/>
			<Selectable
				style={{ height: '45px', fontWeight: '600', fontSize: '15px' }}
				label="NIE"
				onClick={() => FormManager.toggleSelectOCExtendedRisk(false)}
				selected={!props.selectOCExtendedRisk}
			/>
		</Styles.OCBottomSelectables>
	</div>
);

export const OCExtendedContent = () => (
	<PaginatedDescription content={ExtendedContent.OC} />
);
